@if (showHeader !== false) {
  <ion-header>
    <ion-toolbar [color]="computedToolbarColor">
      <ion-buttons slot="start">
        @if (defaultHref) {
          <crowdctrl-back-button
            [defaultHref]="defaultHref"
            [backButtonIcon]="backButtonIcon"
            [backButtonDisabled]="backButtonDisabled || toolbarBusy"
          ></crowdctrl-back-button>
        }
        <ng-content select="[slot=start]"></ng-content>
      </ion-buttons>
      <ion-title>{{ pageTitle }}</ion-title>
      <ion-buttons slot="end">
        <ng-content select="[slot=tenant-selector]"></ng-content>
        @if (showRefresh && !toolbarBusy) {
          <ion-button
            (click)="onRefresh()"
            fill="clear"
            [disabled]="isLoadInFlight || isRefreshCoolingDown"
          >
            <ion-icon name="refresh" slot="icon-only"></ion-icon>
          </ion-button>
        }
        <ng-content select="[slot=header-buttons]"></ng-content>
        <crowdctrl-user-profile-button></crowdctrl-user-profile-button>
      </ion-buttons>
      @if (isLoading || isLoadInFlight || isAutoLoadStalling) {
        <ion-progress-bar
          type="indeterminate"
          [color]="computedProgressBarColor"
        ></ion-progress-bar>
      }
    </ion-toolbar>
    @if (pinnedContent) {
      <ion-toolbar [color]="computedToolbarColor" class="pinned-toolbar">
        <ng-container
          *ngTemplateOutlet="pinnedContent; context: pinnedContentContext"
        ></ng-container>
      </ion-toolbar>
    }
  </ion-header>
} @else {
  <!-- Show progress bar even when header is hidden - just the bar, no header/toolbar -->
  @if (isLoading || isLoadInFlight || isAutoLoadStalling) {
    <div class="headerless-progress-bar">
      <ion-progress-bar type="indeterminate" [color]="computedProgressBarColor"></ion-progress-bar>
    </div>
  }
}

<ion-content [class]="contentHostClasses" [scrollY]="!contentSlotFill">
  @if ((showRefresh || showPwaPullRefresher) && !toolbarBusy && !contentSlotFill) {
    <ion-refresher
      slot="fixed"
      [disabled]="showRefresh && (isLoadInFlight || isRefreshCoolingDown)"
      (ionRefresh)="onIonRefresh($event)"
    >
      <ion-refresher-content
        [pullingText]="showPwaPullRefresher ? 'Pull to check for updates' : undefined"
      ></ion-refresher-content>
    </ion-refresher>
  }
  <div class="page-slot" [class.page-slot--fill]="contentSlotFill">
    <ng-content></ng-content>
  </div>
</ion-content>

<!-- Fixed UI anchored to the viewport (not ion-content; avoids transform/rotation bugs) -->
<ng-content select=".viewport-fixed-slot"></ng-content>

<ng-content select="ion-footer"></ng-content>

@if (shouldShowFooter) {
  <ion-footer>
    <ion-toolbar class="footer-toolbar">
      <ion-title class="version-text">{{ footerText }}</ion-title>
      <ion-buttons slot="end">
        <ion-button
          (click)="onCheckForUpdates()"
          fill="clear"
          size="small"
          class="footer-refresh-button"
        >
          <ion-icon name="refresh" slot="icon-only"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
}
